module.exports = __webpack_public_path__ + "static/media/success.674167bb.png";